import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import api from "../api/Api.js";
import "./DriverSalaryPage.css";
import { Edit2, Save } from "lucide-react";

const AttendanceTable = () => {
  const [driverData, setDriverData] = useState([]);
    const [getfetchBankName, setfetchBankName] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [salBasicList, setfetchBasicSal] = useState([]);
  const [editRow, setEditRow] = useState(null);
  const [formData, setFormData] = useState({});
  const today = new Date().toISOString().split("T")[0];
  const [effDateAdd, setEffDate] = useState(today);

  // ================= FETCH DRIVER =================
  useEffect(() => {
    fetchDriverData();
    fetchBasicSal();
    fetchBankName();
  }, []);

  const fetchDriverData = async () => {
    try {
      const res = await api.get("/adminmod/getDriverData");
      setDriverData(res.data?.data || []);
    } catch {
      toast.error("Failed to load Driver details");
    }
  };

  const fetchBasicSal = async () => {
    try {
      const resp = await api.get("/adminmodSalary/getSalBasicData");
      setfetchBasicSal(resp.data?.data || []);
    } catch {
      toast.error("Failed to load Basic Salary");
    }
  };

    const fetchBankName = async () => {
    try {
      const resp = await api.get("/adminmodSalary/getBankName");
      // console.log(resp);
      setfetchBankName(resp.data?.data || []);
    } catch {
      toast.error("Failed to load Bank Name");
    }
  };

  // ================= HANDLE EDIT CLICK =================
  const handleEdit = (driver) => {
    setEditRow(driver.driver_regno);

    const attendance = getAttendanceByDriver(driver.driver_regno) || {};

    setFormData({
      basicSal: attendance.basic_sal || "",
      bankname: attendance.bankname || "",
      bankbranch: attendance.bankbranch || "",
      bankifsc: attendance.bankifsc || "",
      accno: attendance.accno || "",
    });
  };

  // ================= HANDLE CHANGE =================
  const handleChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  // ================= SAVE DATA =================
  const handleSave = async (driver) => {
    const sendSessionUserId = Number(localStorage.getItem("SessionUserId"));

    try {
      await api.post("/adminmodSalary/saveDriverSalary", {
        driver_regno: driver.driver_regno,
        salary_month: formData.basicSal,
        bankname: formData.bankname,
        bankbranch: formData.bankbranch,
        bankifsc: formData.bankifsc,
        accno: formData.accno,
        sessionUserId: sendSessionUserId,
      });

      toast.success("Saved Successfully");
      setEditRow(null);
      fetchDriverData();
      fetchBasicSal();
    } catch {
      toast.error("Save failed");
    }
  };

  // ================= FILTER =================
  const filteredDrivers = driverData.filter((driver) => {
    const term = searchTerm.toLowerCase();
    const fullName =
      `${driver.driver_fstname} ${driver.driver_mdlname} ${driver.driver_lstname}`.toLowerCase();

    return (
      fullName.includes(term) ||
      driver.driver_regno.toLowerCase().includes(term)
    );
  });

  // ================= FIND BASICSALARY =================
  const getAttendanceByDriver = (driverRegNo) => {
    if (!driverRegNo || !Array.isArray(salBasicList)) return null;
    return salBasicList.find(
      (att) => att.dvr_id?.trim() === driverRegNo?.trim()
    );
  };

  return (
    <div>
      <div className="pageTitle">
        <h2 className="title1">Driver Salary Details</h2>
      </div>

      <div className="attendance-wrapper">
        <div className="controls-container">
          <div className="control-group">
            <label>Search Driver:</label>
            <input
              type="text"
              className="custom-input search-input"
              placeholder="Name or Reg ID..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
        </div>

        <div className="attendance-scroll">
          <table className="attendance-table-daily" style={{ width: "100%" }}>
            <thead>
              <tr>
                <th>#</th>
                <th style={{ textAlign: "center" }}>Driver Name</th>
                
                <th>Contact No</th>
                <th>Salary<br/> per Month</th>
                <th>Bank Name</th>
                <th>Branch Name</th>
                <th>IFSC Code</th>
                <th>Account Number</th>
                <th>Action</th>
              </tr>
            </thead>

            <tbody>
              {filteredDrivers.map((driver, index) => {
                const isEditing = editRow === driver.driver_regno;
                const attendance = getAttendanceByDriver(driver.driver_regno);

                return (
                  <tr key={driver.driver_regno}>
                    <td>{index + 1}</td>

                    <td style={{ textAlign: "center", fontWeight: "500",fontSize:"13px" }}>
                      {driver.driver_fstname} {driver.driver_mdlname}{" "}
                      {driver.driver_lstname}
                      <br/>
                      ({driver.driver_regno})
                    </td>

                    

                    <td style={{ textAlign: "center", fontWeight: "500",fontSize:"13px" }}>
                      <span className="reg-badge">{driver.driver_phno}</span>
                    </td>

                    {/* Salary per Month */}
                    <td style={{ textAlign: "center", fontWeight: "500",fontSize:"13px" }}>
                       {isEditing ? (
                      <input
                        type="text"
                        className="custom-input inputBodySized"
                        disabled={!isEditing}
                        maxLength={"5"}
                        value={
                          isEditing
                            ? formData.basicSal
                            : attendance?.basic_sal ?? "NA"
                        }
                        onChange={(e) =>
                          handleChange("basicSal", e.target.value)
                        }
                      />
                       ) : (
    <span>{attendance?.basic_sal ?? "NA"}</span>
  )}
                    </td>

                    {/* Bank Name */}
   <td style={{ textAlign: "center", fontWeight: "500",fontSize:"13px" }}>
  {isEditing ? (
    <select
      className="custom-input inputBodySized"
      value={formData.bankname}
      onChange={(e) => handleChange("bankname", e.target.value)}
    >
      <option value="" hidden>Select Bank</option>

      {getfetchBankName?.map((bank) => (
        <option key={bank.bankname} value={bank.bankname}>
          {bank.bankname}
        </option>
      ))}
    </select>
  ) : (
    <span>{attendance?.bankname ?? " "}</span>
  )}
</td>
             <td style={{ textAlign: "center", fontWeight: "500",fontSize:"13px" }}>
  {isEditing ? (
    <input
      type="text"
      className="custom-input inputBodySized"
      value={formData.bankbranch}
      onChange={(e) => handleChange("bankbranch", e.target.value)}
    />
  ) : (
    <span>{attendance?.bankbranch ?? " "}</span>
  )}
</td>

                    {/* IFSC Code */}
                    <td style={{ textAlign: "center", fontWeight: "500",fontSize:"13px" }}>
  {isEditing ? (
    <input
      type="text"
      className="custom-input inputBodySized"
      value={formData.bankifsc}
      onChange={(e) => handleChange("bankifsc", e.target.value)}
    />
  ) : (
    <span>{attendance?.bankifsc ?? " "}</span>
  )}
</td>

                    {/* Account Number */}
                  <td style={{ textAlign: "center", fontWeight: "500",fontSize:"13px" }}>
  {isEditing ? (
    <input
      type="text"
      className="custom-input inputBodySized"
      maxLength={"15"}
      value={formData.accno}
      onChange={(e) => handleChange("accno", e.target.value)}
    />
  ) : (
    <span>{attendance?.accno ?? " "}</span>
  )}
</td>

                    {/* ACTION */}
                    <td style={{ textAlign: "center", fontWeight: "500",fontSize:"13px;" }}>
                      {isEditing ? (
                        <button
                          className="btn btn-success btn-sm"
                          onClick={() => handleSave(driver)}
                        >
                          <Save size={16} />
                        </button>
                      ) : (
                        <button
                          className="btn btn-light btn-sm text-primary border-0"
                          onClick={() => handleEdit(driver)}
                        >
                          <Edit2 size={16} />
                        </button>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default AttendanceTable;